import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './inquiry.css';
import { FaBook, FaUserPlus, FaPhoneAlt, FaQuestionCircle } from 'react-icons/fa';
import { FaEye, FaBookOpen } from 'react-icons/fa';

import { Dropdown, Tab, Nav, Form, Button, Card, Col, Row, Modal } from 'react-bootstrap';
import {
  getAssignedAdmissionQueries,
  getSingleAdmissionQuery,
  updateAdmissionQuery,
} from '../../services/queryServices';
const Inquiry = () => {
  //View
  const [show, setShow] = useState(false);

  // Toggle the modal visibility

  // Data to display in the modal
  // const requestData = {
  //   id: '1',
  //   name: 'John Random',
  //   email: 'jhonrandon22@gmail.com',
  //   subject: 'Booking Inquiry',
  //   date: '2024-11-28',
  //   status: 'Pending',
  //   body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic velit ad iure aliquam nostrum recusandae, incidunt deserunt, cum, officiis debitis vitae quibusdam nulla dignissimos a enim beatae quam sunt veniam.',
  // };

  const [selectBtn, setSelectBtn] = useState('Newest');
  const [requestData, setRequestData] = useState({});

  const agents = ['Amit', 'Rahul', 'Neha', 'John']; // Sample agent list
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [showContactedModal, setShowContactedModal] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [statusSummary, setStatusSummary] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('newest');
  const [totalInquiry, setTotalInquiry] = useState(0);
  const [allData, setAllData] = useState([]);
  const pageSize = 10;

  const navigate = useNavigate(); // For navigation to templates page

  const predefinedTemplates = {
    'Flight Availability': 'Here are the details about flight availability...',
    'Travel Policy': 'Here is our travel policy template...',
    'Cancellation Info': 'Here is the cancellation information...',
  };
  // Function to handle status change
  const handleStatusChange = (id, newStatus) => {
    if (newStatus === 'Assigned') {
      setCurrentRowId(id);
      setShowAgentModal(true);
    } else if (newStatus === 'Contacted') {
      setCurrentRowId(id);
      setShowContactedModal(true);
    } else {
      updateStatus(id, newStatus);
    }
  };

  const updateStatus = (id, newStatus) => {
    setTableData((prevData) => prevData.map((row) => (row.id === id ? { ...row, status: newStatus } : row)));
  };

  const handleSendTemplate = (templateName) => {
    const template = predefinedTemplates[templateName];
    alert(`Sending Template: ${templateName}\n\n${template}`);
    setShowContactedModal(false);
    updateStatus(currentRowId, 'Contacted');
  };

  // Function to choose an agent

  const [tableData, setTableData] = useState([]);

  const statusStyles = {
    new: {
      badgeClass: 'bg-success',
      borderColor: '#28a745',
      backgroundColor: 'transparent',
      textColor: '#28a745',
    },

    contacted: {
      badgeClass: 'bg-warning',
      borderColor: '#ffc107',
      backgroundColor: 'transparent',
      textColor: '#ff8c10',
    },
    
    booked: {
      badgeClass: 'bg-warning',
      borderColor: '#ffc107',
      backgroundColor: 'transparent',
      textColor: '#ff8c00',
    },
    closed: {
      badgeClass: 'bg-warning',
      borderColor: '#ffc107',
      backgroundColor: 'transparent',
      textColor: '#ff8c00',
    },
  };

  // List of agents

  // Function to handle clicking on the "responded" status

  const [data, setData] = useState(document.querySelectorAll('#example2_wrapper tbody tr'));
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove('d-none');
      } else {
        data[i].classList.add('d-none');
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll('#example2_wrapper tbody tr'));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const fetchAdmissionQueries = async () => {
    try {
      const data = await getAssignedAdmissionQueries(currentPage, search, pageSize);
      setAllData(data?.queries || []);
      setStatusSummary(data?.statusSummary);
      setTotalInquiry(data?.totalRecords);
      setTotalPages(data?.totalPages); // Ensure this is set
    } catch (error) {
      console.error('Error fetching admission queries:', error);
    }
  };

  const fetchASingleAdmissionQueries = async (queryId) => {
    try {
      const data = await getSingleAdmissionQuery(queryId);
      setRequestData(data.queries);
      // setTableData(data?.queries);
    } catch (error) {
      console.error('Error fetching admission queries:', error);
    }
  };
  const handleShow = (id) => {
    setShow(true);
    fetchASingleAdmissionQueries(id);
  };
  const handleClose = () => setShow(false);
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchAdmissionQueries();
    }, 500); // Delay API call to reduce excessive requests

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage]);

  useEffect(() => {
    let tempData = [...allData];

    // 🔍 **Search Filter**
    if (search.trim()) {
      tempData = tempData.filter(
        (row) =>
          row?.customer?.name?.toLowerCase().includes(search.toLowerCase()) ||
          row?.customer?.email?.toLowerCase().includes(search.toLowerCase())
      );
    }

    // 🔄 **Sorting Fix**
    tempData = tempData.sort((a, b) => {
      if (!a.date || !b.date) return 0; // Avoid sorting errors
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return sort === 'newest' ? dateB - dateA : dateA - dateB;
    });

    setTableData(tempData);
  }, [search, sort, allData]);

  const handleStatusUpdate = async (queryId, newStatus) => {
    try {
      const updatedData = { status: newStatus };

      // Call API to update status
      const updatedQuery = await updateAdmissionQuery(queryId, updatedData);

      // Update tableData state to reflect changes
      fetchAdmissionQueries()   
         alert('Status updated!');
    } catch (error) {
      console.error('Failed to update status:', error);
      alert('Error updating status. Please try again.'); // Show error message
    }
  };

  return (
    <>
      <Row>
        {/* Total Books Card */}
        <Col md={3} className="mb-4">
          <Card
            style={{
              backgroundColor: '#a3c8e6',
              color: 'whitesmoke',
              height: '120px', // Adjusted height
            }}
            className="shadow-sm"
          >
            <Card.Body>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <Card.Title style={{ fontSize: '1.2rem' }}>Total Booked</Card.Title>
                  <Card.Text style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{statusSummary?.booked || 0}</Card.Text>
                </div>
                <FaBookOpen size={30} style={{ position: 'relative', top: '10px' }} />
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Total New Card */}
        <Col md={3} className="mb-4">
          <Card
            style={{
              backgroundColor: '#a3d1a3',
              color: '#fff',
              height: '120px', // Adjusted height
            }}
            className="shadow-sm"
          >
            <Card.Body>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <Card.Title style={{ fontSize: '1.2rem' }}>Total New</Card.Title>
                  <Card.Text style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{statusSummary?.new || 0}</Card.Text>
                </div>
                <FaUserPlus size={30} style={{ position: 'relative', top: '10px' }} />
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Total Contacted Card */}
        <Col md={3} className="mb-4">
          <Card
            style={{
              backgroundColor: '#e1c18f',
              color: '#fff',
              height: '120px', // Adjusted height
            }}
            className="shadow-sm"
          >
            <Card.Body>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <Card.Title style={{ fontSize: '1.2rem' }}>Total Contacted</Card.Title>
                  <Card.Text style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{statusSummary?.contacted || 0}</Card.Text>
                </div>
                <FaPhoneAlt size={30} style={{ position: 'relative', top: '10px' }} />
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Total Inquiries Card */}
        <Col md={3} className="mb-4">
          <Card
            style={{
              backgroundColor: '#a3c9e6',
              color: '#fff',
              height: '120px', // Adjusted height
            }}
            className="shadow-sm"
          >
            <Card.Body>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <Card.Title style={{ fontSize: '1.2rem' }}>Total Closed</Card.Title>
                  <Card.Text style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{statusSummary?.closed || 0}</Card.Text>
                </div>
                <FaQuestionCircle size={30} style={{ position: 'relative', top: '10px' }} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Tab.Container defaultActiveKey="All">
        <div className="d-flex justify-content-end align-items-center flex-wrap">
          <h4 className="responsive-title">Inquiry</h4>

          <div className="card-action coin-tabs mb-1 d-flex align-items-center">
            <style>
              {`
              .custom-placeholder::placeholder {
                color: rgba(255, 99, 132);
                opacity: 1;
              }
            `}
            </style>
            <Form.Control
              type="text"
              placeholder="Search by name or email..."
              // value={searchQuery}
              // onChange={(e) => setSearchQuery(e.target.value)}
              className="custom-placeholder shadow-md"
              style={{
                border: '1px solid rgba(255, 99, 132)',
                height: '50px',
                width: '250px',
                fontWeight: '400',
                fontSize: '14px',
                backgroundColor: 'transparent',
              }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div>
            <div className="newest ms-3">
              <Dropdown>
                <Dropdown.Toggle
                  as="div"
                  className=" btn-select-drop default-select btn i-false"
                  style={{
                    color: '#28a745', // Custom green text
                    borderColor: '#28a745', // Custom green border
                  }}
                >
                  {selectBtn} <i className="fas fa-angle-down ms-2 "></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      setSort('oldest');
                      setSelectBtn('Oldest');
                    }}
                  >
                    Oldest
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setSort('newest');
                      setSelectBtn('Newest');
                    }}
                  >
                    Newest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All" active show>
                    <div className="table-responsive">
                      <div id="example2_wrapper" className="dataTables_wrapper no-footer">
                        <table
                          id="example2"
                          className="table card-table display mb-4 shadow-hover default-table dataTablesCard dataTable no-footer"
                        >
                          <thead>
                            <tr role="row">
                              <th className="sorting">Name</th>
                              <th className="sorting">Email</th>
                              <th className="sorting">Subject</th>
                              <th className="sorting_asc">Date</th>
                              <th className="sorting">Status</th>
                              <th className="sorting">Actions</th>
                              <th className="sorting">Views</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.length > 0 ? (
                              tableData?.map((row, index) => (
                                <tr key={index}>
                                  <td>{row?.customer?.name}</td>
                                  <td>{row?.customer?.email}</td>
                                  <td>{row?.subject}</td>
                                  <td>{row?.date ? new Date(row?.date).toLocaleDateString() : 'N/A'}</td>
                                  <td>
                                    <div>
                                      <span
                                        className={`badge ${statusStyles[row.status]?.badgeClass || 'bg-secondary'}`}
                                        style={{
                                          color: '#fff', // Ensure text color is readable on the badge
                                          // padding: "5px 10px",
                                          borderRadius: '12px',
                                          fontSize: '12px',
                                          fontWeight: '500',
                                          minWidth: '80px', // Consistent width for the menu
                                        }}
                                      >
                                        {row?.status}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        size="sm"
                                        style={{
                                          border: '1px solid',
                                          borderColor: statusStyles[row.status]?.borderColor || '#6c757d',
                                          borderRadius: '10px',
                                          padding: '10px 10px',
                                          fontWeight: '600',
                                          fontSize: '14px',
                                          minWidth: '100px',
                                          backgroundColor: statusStyles[row.status]?.backgroundColor || '#f8f9fa',
                                          color: statusStyles[row.status]?.textColor || '#6c757d',
                                        }}
                                      >
                                        {row.status}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        {Object.keys(statusStyles).map((status) => (
                                          <Dropdown.Item
                                            key={status}
                                            onClick={() => handleStatusUpdate(row._id, status)} // Call API when changing status
                                            style={{ textAlign: 'center' }}
                                          >
                                            {status}
                                          </Dropdown.Item>
                                        ))}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>

                                  {/* Modal for Agent Selection */}
                                  <Modal show={showContactedModal} onHide={() => setShowContactedModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Choose Template</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {Object.keys(predefinedTemplates).map((templateName) => (
                                        <Button
                                          key={templateName}
                                          variant="outline-success"
                                          className="m-2"
                                          onClick={() => handleSendTemplate(templateName)}
                                        >
                                          {templateName}
                                        </Button>
                                      ))}
                                      <hr />
                                      <Button
                                        style={{ background: '#212d60', border: '0px solid' }}
                                        onClick={() => {
                                          navigate('/templates'); // Redirect to Templates Page
                                        }}
                                      >
                                        Manage Templates
                                      </Button>
                                    </Modal.Body>
                                  </Modal>

                                  {/* Modal for Agent Selection */}
                                  <Modal show={showAgentModal} onHide={() => setShowAgentModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Select an Agent</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {['Amit', 'Rahul', 'Neha', 'John'].map((agent) => (
                                        <Button
                                          key={agent}
                                          variant="outline-primary"
                                          className="m-2"
                                          onClick={() => {
                                            setTableData((prev) =>
                                              prev.map((row) =>
                                                row.id === currentRowId
                                                  ? {
                                                      ...row,
                                                      status: 'Assigned',
                                                      agent,
                                                    }
                                                  : row
                                              )
                                            );
                                            setShowAgentModal(false);
                                          }}
                                        >
                                          {agent}
                                        </Button>
                                      ))}
                                    </Modal.Body>
                                  </Modal>

                                  <td>
                                    <Button
                                      style={{
                                        borderRadius: '50%',
                                        padding: '5px',
                                        backgroundColor: 'white',
                                        border: '1px solid black',
                                      }}
                                      onClick={() => handleShow(row?._id)}
                                    >
                                      <FaEye size={23} color="#555" />
                                    </Button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center p-4">
                                  No records found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {tableData.length > 0 && (
                          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                            <div className="dataTables_info">
                              Showing {(currentPage - 1) * pageSize + 1} to{' '}
                              {Math.min(currentPage * pageSize, totalInquiry)} of {totalInquiry} entries
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers mb-0">
                              <Link
                                className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    setCurrentPage(currentPage - 1);
                                    fetchAdmissionQueries();
                                  }
                                }}
                              >
                                <i className="fa fa-angle-double-left"></i> Previous
                              </Link>
                              <span>
                                {[...Array(totalPages)].map((_, i) => (
                                  <Link
                                    key={i}
                                    className={`paginate_button ${currentPage === i + 1 ? 'current' : ''}`}
                                    onClick={() => setCurrentPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Link>
                                ))}
                              </span>
                              <Link
                                className={`paginate_button next ${currentPage >= totalPages ? 'disabled' : ''}`}
                                onClick={() => {
                                  if (currentPage < totalPages) {
                                    setCurrentPage(currentPage + 1);
                                    fetchAdmissionQueries();
                                  }
                                }}
                              >
                                Next <i className="fa fa-angle-double-right"></i>
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
              <div>
                <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="custom-modal">
                  <Modal.Header closeButton>
                    <Modal.Title>Booking Inquiry Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="" style={{ fontSize: '14px' }}>
                    {/* <Card className="p-4 shadow-lg"> */}
                    <Row>
                      <Col md={6}>
                        <h4>Request ID:</h4>
                        <p>{requestData._id}</p>
                      </Col>
                      <Col md={6}>
                        <h4>Name:</h4>
                        <p>{requestData.customer?.name}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <h4>Email:</h4>
                        <p>{requestData.customer?.email}</p>
                      </Col>
                      <Col md={6}>
                        <h4>Subject:</h4>
                        <p>{requestData?.subject}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <h4>Date:</h4>
                        <p>{requestData?.date}</p>
                      </Col>
                      <Col md={6}>
                        <h4>Status:</h4>
                        <p>{requestData?.status}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h4>Message:</h4>
                        <p>{requestData?.description}</p>
                      </Col>
                    </Row>
                    {/* </Card> */}
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default Inquiry;
